namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class ElPodaniZNosiceDlg extends GContentBase<PodListBaseAC>
    {
        TempPath: string;

        private _$fileField: JQuery;

        onContentReady() {
            var that = this;
            PodListBaseAC.InitList(this);
            this.specialActions.push(this.CreateActionPridatSoubor());
            this.specialActions.push(this.CreateActionOdebratSoubor());
            this.specialActions.push(this.CreateActionPodani());
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);
            Gordic.Wfl.ListAC.WflListBaseAC.SetActionVisible(this, Gordic.Gin.Globals.Enums.ActionsName.Obcerstvit, false);
            Gordic.Wfl.ListAC.WflListBaseAC.SetActionVisible(this, Gordic.Gin.Globals.Enums.ActionsName.ZobrazitOperationInfo, false);
            // samotná definice gfilterpanelu
            this.CreateForm();
            this.CreateGrid();
            this.commandBar(this.actions.createBar([
                Gordic.Pod.Globals.ActionsName.elPodani,
                "actCancel",
            ]
            ));

            that.ActionEnabled(false);

        }

        CreateForm() {
            var that = this;
            this._$fileField = $("<div>").gfilefield({
                fileUploaded: (event, data) => this._addFile(data.fileInfo, data.customData),
            })
            var Form = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }) 
                .addSection()
                .addRow({ label: "jres:23900059", required: true }) //RC 23900059 : Poznámka
                .addField("gstringbox", { name: "Poznamka"},)

            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", Form);
        }

        CreateGrid(): void {
            var that = this;
            var gf = Gordic.Wfl.ListAC.WflListBaseAC.GetGridFormat();
            gf.addTextColumn({ name: "FileName", caption: "jres:31950196", width: 400, }) //RC 31950196 : Jméno souboru

            var OpenElPodani = new GAction({     //obsluzna akce, ktera se spousti dbl clickem nad radkem
                name: "gridRowSelectedAct",
                run: function (ev, ctx) {
                    //var rowData = ctx.cellInfo.data; //data, ze kterych byl vytvoren radek
                    //var l_po: string[] = [];
                    //l_po.push(rowData.ixb);
                    //Gordic.Pod.Dialogs.OpenPotvrzeniODoruceniDlg(that, { IdEntity: rowData.ixb }, Global.Enums.ModOtevreni.showModalWindow);
                }
            })
            this.gridOptions = {};
            this.gridOptions.searchColumns = ["FileName"];
            this.gridOptions.defaultAction = OpenElPodani;
            var grid = Gordic.Wfl.ListAC.WflListBaseAC.CreateGridBase(this, gf);
            this.mainGrid = grid;
            Gordic.Wfl.ListAC.WflListBaseAC.AfterCreateGrid(this);
        }

        public addFileDoc()
        {
            this._$fileField.gfilefield("option", "customData", function () { return { isFavorite: true } });
            this._$fileField.gfilefield("instance").inputDiv.trigger("click")
        }

        private _addFile(fileInfo: Gordic.General.ApplicationInterface.GFileInfoDto, customData: any): void {
            var that = this;
            this.call<Gordic.Wfl.Interface.GFilesDto[]>("PridatSoubor", { File: fileInfo, TempPath : this.TempPath })
                .done(function (data)
                {
                    Gordic.Wfl.ListAC.WflListBaseAC.ResolveResultData(that, data);
                    that.ActionEnabled(data.length > 0);
                })
                .always(function () {
                    that.endOperation();
                });
        }

        CreateActionPridatSoubor(): GAction
        {
            var that = this;
            var action = new GAction({
                name: Gordic.Gin.Globals.Enums.ActionsName.Novy,
                icon: Gordic.Gin.Icons.ActionEnum.pridat,
                caption: "jres:23900153", //RC 23900153 : Přidat soubor
                tooltip: "jres:23900153",
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: event => {
                    // this.signModule.signFile({ fileName: "test.pdf", filePath: "D:\\test.pdf", signWithTimeStamp: false }).then((signedConfig) => { ; }, (reason) => { ; })
                    that.addFileDoc();
                }
            });
            return action;
        }

        CreateActionOdebratSoubor(): GAction {
            var that = this;
            var action = new GAction({
                name: Gordic.Gin.Globals.Enums.ActionsName.Odstranit,
                icon: Gordic.Gin.Icons.ActionEnum.odstranit,
                caption: "jres:23900157", //RC 23900157 : Odebrat soubor
                tooltip: "jres:23900157",
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: event => {
                    var l_selected = Wfl.ListAC.WflListBaseAC.GetSelectedIDs(that);
                    if (l_selected.length > 0)
                    {
                        this.call<Gordic.Wfl.Interface.GFilesDto[]>("OdebratSoubor", { Selected: l_selected })
                            .done(function (data) {
                                Gordic.Wfl.ListAC.WflListBaseAC.ResolveResultData(that, data);
                                that.ActionEnabled(data.length > 0);
                            })
                            .always(function () {
                                that.endOperation();
                            });
                    } else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(that);
                }
            });
            return action;
        }

        CreateActionPodani(): GAction {
            let that = this;
            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.elPodani,
                icon: Gordic.Pod.Icons.ActionEnum.elPodani,
                caption: "jres:23900050", //RC 23900050 : Podání do SSL
                tooltip: "jres:23900050",
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: event => { that.Archivuj();           }
            });
            return action;
        }

        private ActionEnabled(enabled: boolean): void
        {
            Gordic.Wfl.ListAC.WflListBaseAC.SetActionEnabled(this, Gordic.Pod.Globals.ActionsName.elPodani, enabled);
            Gordic.Wfl.ListAC.WflListBaseAC.SetActionEnabled(this, Gordic.Gin.Globals.Enums.ActionsName.Odstranit, enabled);
        }

        private Archivuj(): void {

            let that = this;
            let l_Poznamka = that.findFields("Poznamka").gfield("getValue");
            // 21.07.2020 - TFeik
            // Odstranění zpomalovače.
            if (!l_Poznamka) {
                that.dialogs.warning("jres:23900200"); //RC 23900200 : Vyplňte pole poznámka.
                return;
            }

            that.call<string>("Archivovat", { TempPath: that.TempPath, Poznamka: l_Poznamka })
                .done(function (ixb) {
                    var l_po: string[] = [];
                    l_po.push(ixb);
                    Dialogs.EvidenceElPodaniDlg(that, { IxbArray: l_po, PouzePrehled: false }, Global.Enums.ModOtevreni.navigate)
                        .done(function (retVal: any) {
                            if (retVal && retVal.zobrazitDetailPozavreniPruvodce && retVal.pidDokumentu) {
                                var opt = {
                                    DetailDto:
                                    {
                                        ixp: retVal.pidDokumentu
                                    }
                                };
                                Gordic.Wfl.Dialogs.DetailDokumentuSpisu(that, opt).done(function () {
                                    //that.close();
                                });
                            } else {
                                if (that.parentContent) {
                                    if (retVal.pidDokumentu) {
                                        that.parentContent.notification("showToast", { icon: "fa-check", content: "jres:31950335", state: "success" }, { delay: 6 }); //RC 31950335 : Podání proběhlo úspěšně
                                    } else {
                                        that.parentContent.notification("showToast", { icon: "fa-times-circle", content: "jres:31950336", state: "error" }, { delay: 6 }); //RC 31950336 : Podání bylo zrušeno
                                    }
                                }
                                that.close();
                            }
                        });
                })
                .always(function () {
                    that.endOperation();
                });
        }
    }
}
